import {
	shopInfoApi
} from '@/api/index/index'
export default {
	namespaced: true,
	state: {
		id: '',
		shopname: '',
		avatar: '',
		distance: '',
		address: '',
		business_start: '',
		business_end: '',
		mobile: '',
		goods: [],
		posterImg: '',
		categoryList: [],
		province_name: '',
		city_name: '',
		shopStatus: null, // 0 闭店
		shopInfo: null, // 店铺信息
		showedClosePopup: false // 是否已展示闭店弹窗
	},
	mutations: {
		setShopId(state, id) {
			if (state.id != id) {
				state.showedClosePopup = false
			}
			state.id = id
			state.shopInfo = null // 1: 营业中 5: 歇业中
		},
		setShopData(state, data) {
			state.id = data.id
			state.shopname = data.shopName
			state.avatar = data.avatar || 'https://qiniu.tfzhongchukeji.com/imgs/tf_grid_icon.png'
			state.distance = data.distance
			state.posterImg = data.poster

			state.address = data.address
			state.business_start = data.businessStart
			state.business_end = data.businessEnd
			state.mobile = data.mobile
			state.province_name = data.provinceName
			state.city_name = data.cityName
			state.isFollow = data.isFollow
			state.doorhead = data.doorHead
			state.shopStatus = Number(data.shopStatus)
			state.shopInfo = {
				id : data.id,
				shopname : data.shopName,
				avatar : data.avatar || 'https://qiniu.tfzhongchukeji.com/imgs/tf_grid_icon.png',
				distance : data.distance,
				posterImg : data.poster,
				address : data.address,
				business_start : data.businessStart,
				business_end : data.businessEnd,
				mobile : data.mobile,
				province_name : data.provinceName,
				city_name : data.cityName,
				isFollow: data.isFollow,
				lat: data.lat,
				lng: data.lng,
				hasSelf: data.hasSelf,
				hasHot: data.hasHot
			}
		},

		// 更新店铺收藏状态
		setShopFollow(state, data) {
			state.shopInfo.isFollow = data
			state.isFollow = data
		},

		// 更新展示闭店弹窗状态
		updateClosePopup(state, data) {
			state.showedClosePopup = data
		}

	},
	actions: {
		getShopDataByLocationOrId({
			commit
		}, {
			lng,
			lat,
			id
		}) {
			return new Promise((resolve, reject) => {
				shopInfoApi({
					shopId: id
				}).then(res => {
					console.log('shopInfoAPi:', res);
					if (res.code) {
						if (res.code !== 5805) {
							uni.showToast({
								title: res.msg || '店铺信息查询异常',
								icon: 'none'
							})
						}
						reject(res)
					} else {
						commit('setShopData', res.data)
						resolve(res.data)
					}
				}).catch(err => {
					console.log('shopInfo api error:', err);
					if (err?.data?.code) {
						if (err?.data?.code !== 5805) {
							uni.showToast({
								title: err?.data?.msg || '店铺信息查询异常',
								icon: 'none'
							})
						}
						reject(err.data)
						return
					}
					reject(err)
				})
			})

		}
	}
}
